import { useState, useEffect } from "react";
import { useSelector } from "react-redux";

// COMPONENTS Import
import Footer from "../../../../components/LandingPage/Footer";

// SVG Imports
import BackToTop from "../../../../assets/landingPage/TopArrow.svg";
import termsimage from "../../../../assets/Landing/terms.png";

// MUI Import
import { CircularProgress, Typography } from "@mui/material";

const TermsConditions = () => {
  // useState
  const [isVisible, setIsVisible] = useState(false);
  const [scrollPercent, setScrollPercent] = useState(0);

  // useSelector
  const { mobilestatus, webstatus } = useSelector(
    (state) => state.landingpagestate,
  );

  // useEffect
  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 20 || document.documentElement.scrollTop > 20) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  useEffect(() => {
    window.addEventListener("scroll", () => {
      let scrollTop = window.scrollY;
      let docHeight = document.documentElement.scrollHeight;
      let winHeight = window.innerHeight;
      let scrollPercentt = scrollTop / (docHeight - winHeight);
      let scrollPercentRounded = Math.round(scrollPercentt * 100);
      setScrollPercent(scrollPercentRounded);
    });
  }, [scrollPercent]);

  useEffect(() => {
    window.onload = function () {
      setTimeout(function () {
        window.scrollTo(0, 0);
      }, 50);
      setScrollPercent(0);
    };
  }, []);

  function CircularProgressWithLabel(props) {
    return (
      <div sx={{ position: "relative", display: "inline-flex" }}>
        <CircularProgress
          size="59px"
          sx={{ color: "var(--pending)" }}
          variant="determinate"
          {...props}
        />
        <div
          sx={{
            zIndex: 999,
            position: "absolute",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Typography
            variant="caption"
            component="div"
            sx={{ color: "text.secondary" }}
          >
            <img
              src={BackToTop}
              alt="back to top"
              width="50"
              style={{ right: "45px", position: "fixed", bottom: "34px" }}
            />
          </Typography>
        </div>
      </div>
    );
  }

  return (
    <div>
      <div>
        {isVisible && (
          <div
            onClick={scrollToTop}
            className="fixed bottom-[25px] right-[40px] cursor-pointer z-20"
          >
            <CircularProgressWithLabel value={scrollPercent} />
          </div>
        )}
        <>
          <div
            style={{
              overflow: webstatus ? "hidden" : "",
              overflowY: mobilestatus && "hidden",
              height: "100vh",
              scrollbarWidth: "none",
              msOverflowStyle: "none",
              WebkitOverflowScrolling: "touch",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div className="flex flex-col justify-center items-center relative pt-[88px] bg-[#1d3a6d] flex-1">
              <div className="h-full max-w-[1024px] w-screen flex justify-center mx-auto relative Qsm:flex-col">
                <div className="gap-5 w-full flex flex-col Qsm:flex-row md:flex-row items-center justify-between py-5 px-5">
                  <div className="w-full md:w-1/2 order-1 md:order-2 flex justify-end items-center">
                    <img
                      className="landingimg w-[380px] h-[180px] Qsmd:w-[378px] Qsmd:h-[226px]"
                      src={termsimage}
                      alt="Terms and Conditions"
                    />
                  </div>
                  <div className="text-center">
                    <h2 className="text-font-md Qsmd:text-font-xl pb-2 text-text-primary font-semibold">
                      <span className="text-pending">XPENTRA PLATFORM </span>
                      TERMS OF USE
                    </h2>
                  </div>
                </div>
              </div>
            </div>
            <div className="text-text-primary text-sm bg-[#031F4F] px-4 py-5 Qsmd:px-[120px] Qsmd:py-[64px] flex flex-col gap-10">
              <div className="gap-5 flex flex-col">
                <p className="text-justify">
                  These Terms of Use (“
                  <span className="font-semibold">Terms</span>”) are issued by
                  Q2Pay Technologies Private Limited, a company duly
                  incorporated under the provisions of the Companies Act, 2013
                  and having its registered office at 7th Floor, A Wing, Mumbai
                  Education Trust, General A.K. Vaidya Road, Bandra (West),
                  Mumbai – 400050 (“
                  <span className="font-semibold">Company</span>”).
                </p>
                <p className="text-justify">
                  The Company is a B2B fintech company inter alia engaged in the
                  development, deployment and management of proprietary software
                  products, platforms and digital solutions and has developed
                  the “Xpentra Platform” (“
                  <span className="font-semibold">Platform</span>”) as a
                  Software-as-a-Service (SaaS) solution. These Terms govern
                  access to and use of the said Platform by each Subscriber that
                  subscribes to and/or uses the Platform.
                </p>
                <p className="text-justify">
                  For the purposes of these Terms, “Subscriber” means any
                  individual, company, partnership, limited liability
                  partnership, trust, body corporate or other legal entity that
                  subscribes to and/or uses the Platform and shall, unless the
                  context otherwise requires, include all of its directors,
                  officers, employees, representatives, consultants, contractors
                  and other persons authorised by it to access or use the
                  Platform.
                </p>
                <p className="text-justify">
                  By signing the acknowledgement forming part of these Terms and
                  accessing and/or using the Platform, the Subscriber agrees to
                  comply with these Terms and shall be responsible for ensuring
                  compliance by all Person(s) accessing the Platform on its
                  behalf.
                </p>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 1 :&nbsp;
                  <span className="text-pending">
                    DEFINITIONS AND CONSTRUCTIONS
                  </span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <span>
                    <p className="font-semibold">1.1 Definitions</p>
                    When used herein, the defined terms set forth in this
                    ARTICLE 1 shall have the following respective meanings.
                  </span>

                  <p className="text-justify">
                    (a) “<span className="font-semibold">Admin</span>” shall
                    mean a User designated by the Subscriber with administrative
                    privileges to create and manage User Accounts and to
                    configure roles, permissions, and approval matrices within
                    the Platform.
                  </p>
                  <p className="text-justify">
                    (b) “<span className="font-semibold">Affiliate</span>” shall
                    mean when used in reference to a specified Person, any legal
                    entity that directly or indirectly controls, is controlled
                    by or is under common control with the specified Person.
                  </p>
                  <p className="text-justify">
                    (c) “<span className="font-semibold">Applicable Law</span>”
                    shall mean all applicable statutes, act of legislature or
                    Parliament, laws, bye-laws, enactments, regulations,
                    ordinances, policies, treaties, rules, notifications,
                    circulars, government resolutions, directions, directives,
                    permits, guidelines, requirements, licenses, rules of common
                    laws, orders, decrees, judgments, injunctions, writs or
                    orders of any court of record having the force of law, or
                    any restrictions or conditions including any similar form of
                    decision of, or determination, application or execution by,
                    or interpretation or pronouncement having the force of law
                    of, any Authority having jurisdiction over the matter in
                    question, whether in effect as on the date of these Terms or
                    thereafter and shall include any re-enactment, substitution
                    or amendment thereof as may be in force and effect during
                    the subsistence of these Terms which the Parties are
                    required to comply with for the proper conduct of its
                    business and maintenance of assets or properties.
                  </p>
                  <p className="text-justify">
                    (d) “
                    <span className="font-semibold">
                      Confidential Information
                    </span>
                    ” shall mean all the contents of these Terms and any or all
                    such non-public information which is clearly stated, marked,
                    identified or designated by either Party to be proprietary
                    or confidential and / or which, under the given
                    circumstances ought to be treated as confidential and
                    includes inter alia, the said Party’s business policies or
                    practices, business plans, dealings, price lists or pricing
                    structure, technical data, employee data or officer data,
                    details of revenues, findings, ideas, concepts, know-how,
                    other non-generic information whether tangible and / or
                    intangible, written and / or oral, relating to any released
                    / unreleased concepts, ideas, projects and Services of the
                    said Party and any other information received from other
                    sources which the other Party is obliged to treat as
                    confidential.
                  </p>
                  <p className="text-justify">
                    (e) “
                    <span className="font-semibold">Data Protection Laws</span>”
                    shall mean all applicable data protection legislation
                    including the Digital Personal Data Protection Act, 2023 (“
                    <span className="font-semibold">DPDP Act</span>”), and the
                    rules thereunder upon enforcement, Information Technology
                    Act, 2000, the Information Technology (Reasonable Security
                    Practices and Procedures and Sensitive Personal Data or
                    Information) Rules, 2011, the Indian Computer Emergency
                    Response Team Directions, 2022, including any rules,
                    regulations, notifications, directions, guidelines thereto,
                    as amended from time to time.
                  </p>
                  <p className="text-justify">
                    (f) “<span className="font-semibold">Data Processor</span>”,
                    “<span className="font-semibold">Data Fiduciary</span>”, “
                    <span className="font-semibold">Data Principal</span>” and “
                    <span className="font-semibold">Personal Data</span>” shall
                    mean to have the meanings assigned to them under the DPDP
                    Act and the rules thereunder.
                  </p>
                  <p className="text-justify">
                    (g) “
                    <span className="font-semibold">Intellectual Property</span>
                    ” shall mean any patent, copyright, design right, registered
                    design, trade mark, service mark, trade name, domain name,
                    algorithms, user interface designs, benchmark data,
                    architecture, know-how, database right, utility model,
                    unregistered design or other industrial or intellectual
                    property rights subsisting throughout the world, whether or
                    not registered and all applications, renewals and extensions
                    of the same.
                  </p>
                  <p className="text-justify">
                    (h) “<span className="font-semibold">Person</span>” shall
                    mean any natural person, company, corporation, partnership
                    (whether limited or unlimited), proprietorship, Hindu
                    Undivided Family, Trust, Union, Association, Government or
                    any agency or political subdivision thereof or any other
                    entity that may be treated as a person under applicable law.
                  </p>
                  <p className="text-justify">
                    (i) “<span className="font-semibold">Platform</span>” shall
                    mean the proprietary Xpentra platform, together with all
                    associated modules, applications, APIs, dashboards,
                    integrations, interfaces, workflows, reports, documentation
                    and related services.
                  </p>
                  <p className="text-justify">
                    (j) “<span className="font-semibold">Purpose</span>” shall
                    mean non-commercial usage (i.e. use/ access of the Platform
                    by the Subscriber other than for sale or exploitation
                    itself) of the Platform by the Subscriber.
                  </p>
                  <p className="text-justify">
                    (k) “<span className="font-semibold">Services</span>” shall
                    mean the subscription-based services comprising access to
                    and use of the Platform provided by the Company to the
                    Subscriber, during the subscription period. Services shall
                    not include any consultancy, advisory, management services,
                    outsourcing, business process services or custom
                    professional services, in any manner.
                  </p>
                  <p className="text-justify">
                    (l) “<span className="font-semibold">Subscriber Data</span>”
                    shall mean all data and information uploaded, transmitted,
                    stored, processed or otherwise made available through the
                    Platform by or on behalf of the Subscriber or its Users.
                  </p>
                  <p className="text-justify">
                    (m) “<span className="font-semibold">Subscription</span>”
                    shall mean the license granted by the Company to the
                    Subscriber to access and use the Platform during the
                    applicable subscription period.
                  </p>
                  <p className="text-justify">
                    (n) “<span className="font-semibold">Transaction</span>”
                    shall mean workflows, instructions, approvals, requests,
                    reconciliations, reporting actions, exports, or other
                    activities initiated by the Subscriber or its Users through
                    the Platform, including where such activity results in
                    messages or instructions being transmitted to third parties
                    such as banks or other integration partners.
                  </p>
                  <p className="text-justify">
                    (o) “<span className="font-semibold">User</span>” shall mean
                    an individual authorized by the Subscriber to access the
                    Platform.
                  </p>
                  <p className="text-justify">
                    (p) “<span className="font-semibold">User Accounts</span>”
                    shall mean a unique account created by the Subscriber
                    through the Admin account for a User to access the Platform.
                  </p>
                  <p className="text-justify">
                    (q) The meanings set forth for defined terms in this ARTICLE
                    and all pronouns shall be equally applicable to both the
                    singular and plural; masculine, feminine or neuter forms as
                    the context may require.
                  </p>
                  <p className="text-justify">
                    (r) All references in these Terms to Articles are to
                    Articles in or to these Terms unless otherwise specified
                    therein. The words “hereof,” “herein” and “hereunder” and
                    words of similar import when used in these Terms shall refer
                    to these Terms as a whole and not to any particular
                    provision of these Terms. The words “include”, “including”
                    and “among other things” shall be deemed to be followed by
                    “without limitation” or “but not limited to” whether or not
                    they are followed by such phrases or words of like import.
                  </p>
                  <p className="text-justify">
                    (s) References in these Terms to any document or agreement
                    shall be deemed to include references to such document or
                    agreement as amended, varied, restated, supplemented or
                    replaced from time to time in accordance with the terms
                    thereof and to include any side letters executed in
                    connection therewith, except as otherwise provided in these
                    Terms.
                  </p>
                  <p className="text-justify">
                    (t) The headings of the several Articles and sub clauses of
                    these Terms are intended for convenience only and shall not
                    in any way affect the meaning or construction of any
                    provision therein.
                  </p>
                  <p className="text-justify">
                    (u) References to writing include printing, typing,
                    lithography and other means of reproducing words in a
                    visible form.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 2 :&nbsp;
                  <span className="text-pending">GRANT OF ACCESS</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    2.1 Subject to these Terms and in consideration of payment
                    of the Subscription fees by the Subscriber, the Company
                    grants the Subscriber a limited, non-exclusive,
                    non-transferable, non-sublicensable and revocable right to
                    use and access the Platform during the subscription period,
                    solely for its internal business purposes. It is clarified
                    that this right does not transfer any ownership or
                    Intellectual Property in the Platform to the Subscriber.
                  </p>
                  <p className="text-justify">
                    2.2 The Company shall have no obligation to provide any
                    access to the Platform until the Company receives the
                    “One-Time Setup Fees” as may be applicable, from the
                    Subscriber.
                  </p>
                  <p className="text-justify">
                    2.3 The Platform is provided on an “as-is” and
                    “as-available” basis and the Company does not represent
                    and/or warrant that the Platform is fit for any particular
                    use case of the Subscriber. The Company may, at its sole
                    discretion, consider requests for any customization and/or
                    bespoke development of the Platform. In the event, the
                    Company elects to proceed with such customization, the
                    Parties shall mutually discuss and shall agree in writing
                    with respect to additional fees, timelines and other
                    applicable terms for any such request for customization.
                  </p>
                  <p className="text-justify">
                    2.4 The Company may require KYC, corporate documentation,
                    board resolutions, GST registrations, authorization letters
                    or other information necessary to verify the Subscriber. The
                    Subscriber acknowledges that failure to provide such
                    information may result in suspension or refusal of access.
                  </p>
                  <p className="text-justify">
                    2.5 Nothing contained in these Terms shall be construed as
                    requiring the Company to provide banking services, regulated
                    payment system services, financial advisory, accounting,
                    legal or fiduciary services unless expressly agreed by the
                    Company in writing.
                  </p>
                  <p className="text-justify">
                    2.6 The Company reserves all rights not expressly granted
                    under these Terms.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 3 :&nbsp;
                  <span className="text-pending">
                    SUBSCRIBER’S OBLIGATIONS AND ACCEPTABLE USE
                  </span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    3.1 The Subscriber shall use the Platform only for lawful
                    business purposes and only for legitimate and lawful
                    Transactions. The Subscriber shall be responsible for all
                    activities undertaken through its account and shall be
                    solely responsible for the acts and omissions of its Users.
                    The Subscriber acknowledges that it shall remain solely
                    responsible for all business decisions, approvals, payment
                    instructions, financial transactions, reconciliations,
                    statutory compliances and regulatory obligations undertaken
                    through or in connection with the Platform and that the
                    Company shall not be liable for any loss arising from the
                    Subscriber’s reliance upon any information, report or output
                    generated through the Platform without appropriate review
                    and validation by the Subscriber.
                  </p>
                  <p className="text-justify">
                    3.2 Enterprise subscriptions shall be registered in the
                    legal name of the Subscriber. The Subscriber represents that
                    all the information provided during such registration,
                    including but not limited to legal name, registered address,
                    GST information, banking details, authorized signatory
                    details, email addresses, telephone numbers and User
                    information is accurate and complete. The Subscriber
                    acknowledges that providing false information constitutes a
                    material breach of these Terms.
                  </p>
                  <p className="text-justify">
                    3.3 The Subscriber acknowledges that the Platform may be
                    configured or customized by or on behalf of the Subscriber
                    to reflect its organizational structure, approval
                    hierarchies, workflows, business rules, user permissions,
                    integrations and operational requirements and that the
                    Subscriber shall be solely responsible for the accuracy,
                    completeness, testing, implementation and ongoing
                    maintenance of such configurations and for ensuring that
                    they accurately reflect its internal policies, delegations
                    of authority, business processes and compliance
                    requirements. Unless expressly agreed by the Company in
                    writing, the Company shall have no obligation to review,
                    validate or monitor any configuration established by or on
                    behalf of the Subscriber and shall not be responsible for
                    any loss, delay, unauthorized transaction or operational
                    consequence arising from any configuration error, omission
                    or modification.
                  </p>
                  <p className="text-justify">
                    3.4 The Subscriber acknowledges that the Company shall be
                    entitled to rely upon and act on any instruction, request,
                    approval, authorization or communication received through
                    the Platform using the Subscriber’s designated accounts,
                    authorized credentials or approved authentication mechanisms
                    and may treat the same as having been duly authorized by the
                    Subscriber. Except to the extent expressly required under
                    Applicable Law or these Terms, the Company shall not be
                    obliged to independently verify the identity, authority or
                    authenticity of any person issuing such instruction. The
                    Subscriber shall remain solely responsible for establishing,
                    implementing and maintaining appropriate internal approval
                    workflows, authorization matrices, segregation of duties and
                    security controls governing access to and use of the
                    Platform.
                  </p>
                  <p className="text-justify">
                    3.5 The Subscriber shall not reverse engineer/ copy/ modify
                    the Platform and/or interfere with the security/ operation
                    of the Platform and/or upload malicious software or harmful
                    code and/or use the Platform to develop or support a
                    competing product/ service.
                  </p>
                  <p className="text-justify">
                    3.6 The Subscriber shall not use the Platform for any
                    unlawful or fraudulent purposes, in any manner and shall not
                    permit any unauthorized third party to access the Platform.
                    Where the Platform facilitates treasury management, payment
                    processing or financial workflow automation, the Subscriber
                    shall remain solely responsible for ensuring that its use of
                    the Platform complies with all Applicable Laws, regulatory
                    requirements, internal governance policies and approval
                    processes applicable to its business.
                  </p>
                  <p className="text-justify">
                    3.7 The Company may suspend access to the Platform where it
                    reasonably believes that these Terms have been breached by
                    the Subscriber.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 4 :&nbsp;
                  <span className="text-pending">SUBSCRIPTION AND FEES</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    4.1 The Platform may be made available under one or more
                    Subscription plans, each of which may provide access to
                    different modules, features, functionality, user limits,
                    storage limits, integrations, APIs, transaction limits,
                    support levels or other entitlements. The Subscriber
                    acknowledges that the Company may introduce, modify,
                    discontinue or replace Subscription plans from time to time
                    and that access to any particular feature shall depend upon
                    the subscription plan purchased by the Subscriber. Nothing
                    contained in these Terms obligates the Company to continue
                    offering any particular subscription plan indefinitely.
                  </p>
                  <p className="text-justify">
                    4.2 Unless otherwise agreed in writing, Subscriptions
                    commence on the date access is first enabled by the Company
                    and continue for the Subscription period purchased by the
                    Subscriber. The Subscriber may request upgrades, additional
                    modules, increased user licenses or enhanced functionality
                    during the Subscription period. Such upgrades shall become
                    effective upon acceptance by the Company and payment of the
                    applicable charges. Downgrades shall take effect only upon
                    renewal unless otherwise agreed by the Company.
                  </p>
                  <p className="text-justify">
                    4.3 Access to the Platform is subject to the applicable
                    Subscription purchased by the Subscriber. Unless otherwise
                    agreed in writing, all fees are payable in accordance with
                    the applicable invoice terms and are non-refundable. In the
                    event of delay in payment of the Subscription fees beyond
                    the periods stipulated in the invoice, then without
                    prejudice to the Company’s right to suspend/ terminate the
                    Subscription, the Subscriber shall be required to pay such
                    interest, as set out in the invoice. It is clarified that
                    the foregoing remedy is independent of, and in addition to,
                    any other rights and remedies that the Company may have
                    under these Terms or under law or in equity or otherwise.
                  </p>
                  <p className="text-justify">
                    4.4 All fees are exclusive of any goods and services tax (“
                    <span className="font-semibold">GST</span>”) and/or any
                    other similar succeeding tax or any other applicable
                    statutory tax, which shall be borne by the Subscriber in
                    addition to the fees. The Subscriber shall be entitled to
                    deduct only the applicable withholding tax on the Fees,
                    before paying the same to the Company, as per the provisions
                    of the Income Tax Act, 1961. The Subscriber shall provide
                    the Company with the requisite TDS certificates in time
                    under the provisions of the Income Tax Act, 1961. The
                    Subscriber shall be required to provide the applicable tax
                    deducted at source (“
                    <span className="font-semibold">TDS</span>”) certificate,
                    evidencing such deduction. The TDS certificate will be
                    provided within 30 (thirty) days of each payment or before
                    the end of the financial year if it falls before the 30
                    (thirty) days of a payment being made or as required by law,
                    whichever is earlier.
                  </p>
                  <p className="text-justify">
                    4.5 If any amount owing by the Subscriber to the Company is
                    overdue beyond the payment terms stipulated under the
                    invoice, the Company may, without prejudice to its other
                    rights and remedies, accelerate unpaid fee obligations and
                    suspend and/or downgrade/ limit the Services under the
                    Subscription, until such amount(s) are paid in full to the
                    Company by the Subscriber.
                  </p>
                  <p className="text-justify">
                    4.6 The Company may, at its sole discretion, provide free
                    trials and/or proofs of concepts and/or demonstration
                    environments and/or pilot deployments and/or beta releases
                    and/or pre-release features or experimental functionality.
                    The Subscriber acknowledges that such services are provided
                    solely for evaluation purposes. Unless expressly stated
                    otherwise, such free trials are provided “as-is”, without
                    any commitment of uptime and/or support and the features may
                    be modified and/or discontinued without notice to the
                    Subscriber. The Company shall have no liability arising out
                    of the use of free trial services.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 5 :&nbsp;
                  <span className="text-pending">
                    SUBSCRIBER DATA AND PRIVACY
                  </span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    5.1 The Subscriber shall retain all right, title and
                    interest in and to the Subscriber Data uploaded to or
                    generated through the Platform. The Subscriber grants the
                    Company a limited, non-exclusive license to access, host,
                    store, process and transmit Subscriber Data solely for the
                    purpose of providing, maintaining, securing and improving
                    the Services, complying with Applicable Law and fulfilling
                    its contractual obligations.
                  </p>
                  <p className="text-justify">
                    5.2 The Subscriber represents and warrants that it has
                    obtained all necessary rights, approvals and consents
                    required to upload and process the Subscriber Data through
                    the Platform. The Subscriber acknowledges that the Company
                    shall not verify the legality or accuracy of the Subscriber
                    Data.
                  </p>
                  <p className="text-justify">
                    5.3 The Subscriber shall collect all relevant data and
                    Personal Data necessary for the Subscriber’s use of the
                    Platform. The Subscriber shall ensure at its sole liability
                    and obligation the accuracy, quality, integrity,
                    reliability, completeness and the right without encumbrance
                    to use all relevant data and Personal Data, including
                    without limitation ownership and/or adequate right and title
                    to any Intellectual Property to be provided by the
                    Subscriber. The Company shall not be responsible for any
                    loss arising from inaccurate, incomplete or corrupted
                    Subscriber Data uploaded by the Subscriber.
                  </p>
                  <p className="text-justify">
                    5.4 Depending upon the Subscriber’s use of the Platform,
                    Subscriber Data may include Personal Data relating to
                    Subscriber’s Users, employees, authorized signatories,
                    finance and treasury personnel, vendors, customers, and
                    other individuals introduced by Subscriber, and may include
                    identifiers, contact details, role information,
                    authentication data, transactional metadata and audit logs.
                    The Subscriber agrees and understands that it is responsible
                    for ensuring compliance with any and all regulations and
                    Laws relating to the collection and usage of such Personal
                    Data, as may be applicable, including without limitation any
                    requirements relating to consent, purpose, usage, transfers
                    (including cross-border transfers), and any other
                    requirements as may be applicable. In the event of any
                    non-compliance relating to privacy and/or data protection
                    with any laws, attributable to an act or omission by the
                    Subscriber, the Subscriber shall indemnify the Company for
                    any claims incurred as a result of or in relation to such
                    non-compliance.
                  </p>
                  <p className="text-justify">
                    5.5 The Subscriber acknowledges that for the purposes of the
                    DPDP Act, the Subscriber is the Data Fiduciary in respect of
                    all Personal Data processed through the Platform, and the
                    Company merely acts as a Data Processor processing Personal
                    Data strictly on documented instructions of the Subscriber
                    and solely for the purpose of providing access to,
                    operating, securing, maintaining, and supporting the
                    Platform. The Company does not determine the purpose or
                    means of processing Personal Data and shall not be treated
                    as a Data Fiduciary or Significant Data Fiduciary in respect
                    of Subscriber Data, in any manner.
                  </p>
                  <p className="text-justify">
                    5.6 The Parties expressly record that processing by the
                    Company as Data Processor may include, to the extent
                    necessary for Platform provision, user authentication,
                    access control and role enforcement, workflow routing and
                    notifications, execution of approval matrices configured by
                    the Subscriber, audit logging and activity history
                    generation, report generation and export functionalities
                    initiated by Users, backups and disaster recovery,
                    monitoring, detection and prevention of security incidents
                    and abuse, troubleshooting issues raised by Subscriber, and
                    compliance with directions of competent authorities to the
                    extent applicable to a platform provider.
                  </p>
                  <p className="text-justify">
                    5.7 The Company shall retain Subscriber Data only as
                    necessary for Platform provision and thereafter only to the
                    extent required for legitimate purposes including security
                    logging, fraud/abuse prevention, dispute defense, and
                    compliance with Applicable Laws.
                  </p>
                  <p className="text-justify">
                    5.8 The Subscriber authorizes the Company to engage
                    sub-processors solely as necessary for Platform provision
                    (including hosting, monitoring, incident management and
                    security tooling), provided that sub-processors are bound by
                    obligations no less protective than these Terms and the
                    Company remains responsible for them to the extent of its
                    own obligations.
                  </p>
                  <p className="text-justify">
                    5.9 Subject to confidentiality and security limitations, the
                    Company shall provide reasonable information and cooperation
                    to enable the Subscriber to meet Data Fiduciary obligations,
                    provided that audits shall be limited in scope, shall not
                    require disclosure of security-sensitive information that
                    could compromise the Platform or other customers of the
                    Company, and Subscriber shall bear reasonable costs where
                    assistance is substantial.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 6 :&nbsp;
                  <span className="text-pending">
                    INFORMATION SECURITY AND BUSINESS CONTINUITY
                  </span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    6.1 The Company shall implement and maintain commercially
                    reasonable administrative, technical, physical and
                    organizational safeguards designed to protect the
                    confidentiality, integrity and availability of the Platform
                    and Subscriber Data against unauthorized access,
                    acquisition, use, disclosure, alteration, loss or
                    destruction.
                  </p>
                  <p className="text-justify">
                    6.2 The Company shall maintain commercially reasonable
                    backup, disaster recovery and business continuity measures
                    appropriate to the nature, scale and criticality of the
                    Services, with the objective of supporting the continued
                    availability and recovery of the Platform following a
                    disruption or disaster.
                  </p>
                  <p className="text-justify">
                    6.3 The Company shall notify the Subscriber without undue
                    delay, and in any event within a commercially reasonable
                    period after becoming aware of any confirmed Security
                    Incident that has materially affected, or is reasonably
                    likely to materially affect, the confidentiality, integrity
                    or availability of the Subscriber Data. The Company shall
                    use commercially reasonable efforts to investigate, contain,
                    mitigate and remediate the effects of such Security Incident
                    and shall provide the Subscriber with such information
                    regarding the incident as may be reasonably necessary to
                    enable the Subscriber to comply with its legal or regulatory
                    obligations. For the purposes of these Terms, a “Security
                    Incident” means any unauthorized access to, acquisition of,
                    disclosure of, alteration of, loss of, destruction of, or
                    inability to access Subscriber Data or the Platform that
                    materially compromises the confidentiality, integrity or
                    availability thereof. Security Incidents shall not include
                    unsuccessful attempts or activities that do not result in a
                    material compromise of the Platform or Subscriber Data,
                    including scans, probes, port scans, denial-of-service
                    attempts, unsuccessful login attempts, firewall events or
                    similar routine network activity.
                  </p>
                  <p className="text-justify">
                    6.4 The Subscriber acknowledges that no software,
                    information technology system, network, electronic storage
                    mechanism or method of transmission over the internet can be
                    guaranteed to be completely secure, uninterrupted or free
                    from vulnerabilities. Except as expressly provided in these
                    Terms, the Company does not warrant that the Platform will
                    be immune from cyber-attacks, malicious code, unauthorized
                    access, service interruptions or other security events
                    despite the implementation of commercially reasonable
                    safeguards.
                  </p>
                  <p className="text-justify">
                    6.5 The Subscriber shall implement and maintain appropriate
                    administrative, technical and organizational security
                    measures for its own systems, devices, networks and user
                    credentials and shall remain responsible for all access to
                    and use of the Platform through its accounts, including
                    access by persons authorized by it.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 7 :&nbsp;
                  <span className="text-pending">CONFIDENTIALITY</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    7.1 Each Party shall maintain the confidentiality of all
                    Confidential Information received from the other Party and
                    shall use such information solely for the purposes of these
                    Terms.
                  </p>
                  <p className="text-justify">
                    7.2 The Subscriber acknowledges and agrees that it shall
                    not, directly or indirectly, reverse engineer, disassemble
                    or decompile or otherwise attempt to discover the source
                    code, object code or underlying structure, ideas, know-how
                    or algorithms relevant to the Services, Platform,
                    documentation or data related to the Services and/or modify,
                    translate, or create derivative works based on the Platform
                    (except to the extent expressly permitted by Company or
                    authorized as a part of these Terms) and/or remove any
                    proprietary notices or labels of the Platform/ the Company
                    and/or distribute or make available to any third party, all
                    or any part of the Platform and Services. The Subscriber
                    acknowledges that the Company shall be entitled to seek
                    injunctive and equitable relief, without the requirement to
                    prove actual damages, in the event of any breach or
                    threatened breach of these terms.
                  </p>
                  <p className="text-justify">
                    7.3 The confidentiality obligations shall not apply to
                    information that is or becomes publicly available through no
                    fault of the receiving Party and/or was lawfully known prior
                    to disclosure and/or is independently developed without
                    reference to the Confidential Information and/or is required
                    to be disclosed by law or a competent authority.
                  </p>
                  <p className="text-justify">
                    7.4 The Confidentiality obligations shall survive
                    termination of these Terms for a period of five (5) years,
                    except in relation to trade secrets and proprietary
                    technology, which shall remain confidential for so long as
                    they retain their confidential character.
                  </p>
                  <p className="text-justify">
                    7.5 Unless otherwise agreed in writing, the Company may
                    identify the Subscriber as a customer in its marketing
                    materials, investor presentations, website, case studies and
                    customer lists solely by displaying the Subscriber’s
                    corporate name and logo. The Company shall not disclose
                    Confidential Information in connection with such use.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 8 :&nbsp;
                  <span className="text-pending">INTELLECTUAL PROPERTY</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    8.1 The Platform, including all software, source code,
                    object code, interfaces, documentation, workflows, reports,
                    trademarks, logos and all associated intellectual property
                    rights, are and shall remain the exclusive property of the
                    Company or its licensors. Except for the limited right to
                    use the Platform during the Subscription Period, no license
                    or ownership rights are granted to the Subscriber, in any
                    manner.
                  </p>
                  <p className="text-justify">
                    8.2 Any suggestions/ recommendations/ feedback provided by
                    the Subscriber regarding the Platform may be used by the
                    Company without restriction or obligation to the Subscriber.
                  </p>
                  <p className="text-justify">
                    8.3 All improvements made to the Platform arising from
                    processing Subscriber Data shall belong exclusively to the
                    Company, provided such improvements do not incorporate
                    identifiable Subscriber Data.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 9 :&nbsp;
                  <span className="text-pending">THIRD PARTY SERVICES</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    9.1 The Platform may integrate with banks, payment service
                    providers, ERP systems, accounting software or other
                    third-party applications. Such integrations are provided
                    solely for the Subscriber’s convenience. It is clarified
                    that the Company does not own or control such third-party
                    services and shall not be responsible for their
                    availability, performance, security or compliance and that
                    the Subscriber’s use of any third-party service shall be
                    governed by the terms and conditions of the relevant third
                    party, as may be applicable.
                  </p>
                  <p className="text-justify">
                    9.2 Where the Platform integrates with any enterprise
                    resource planning system, banking platform, payment gateway,
                    application programming interface (API), accounting software
                    or other third-party system selected by the Subscriber, the
                    Subscriber shall be responsible for ensuring that all
                    necessary approvals, permissions, licenses and credentials
                    have been obtained and remain valid, the data exchanged
                    through such integrations is accurate, complete and
                    authorized and that the integrated systems are configured,
                    maintained and operated in accordance with the applicable
                    third-party requirements and the Subscriber’s internal
                    policies.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 10 :&nbsp;
                  <span className="text-pending">
                    WARRANTIES AND DISCLAIMERS
                  </span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <span className="gap-1 flex flex-col">
                    <p className="text-justify">
                      10.1 Each Party represents and warrants that:
                    </p>
                    <p className="text-justify">
                      (a) it has full power and authority to enter into these
                      Terms;
                    </p>
                    <p className="text-justify">
                      (b) acceptance of these Terms does not violate any
                      Applicable Law or binding obligation;
                    </p>
                    <p className="text-justify">
                      (c) it shall comply with Applicable Law;
                    </p>
                    <p className="text-justify">
                      (d) these Terms constitute valid and binding obligations
                      enforceable against it.
                    </p>
                  </span>
                  <p className="text-justify">
                    10.2 The Subscriber further represents and warrants that it
                    has obtained all necessary approvals to use the Platform and
                    that all information provided to the Company is accurate and
                    complete. The Subscriber further represents and warrants
                    that it shall comply with all financial, tax, regulatory,
                    anti-money laundering, sanctions and data protection laws
                    applicable to its business.
                  </p>
                  <p className="text-justify">
                    10.3 The Company warrants that it has the right to provide
                    the Services contemplated under these Terms. Except as
                    expressly stated herein, the Platform and Services are
                    provided on an “as is” and “as available” basis. The Company
                    does not warrant that the Platform will operate without
                    interruption/ error and/or every defect will be corrected
                    and/or the Platform will be compatible with every
                    third-party system and/or every output generated by the
                    Platform will be complete or error-free. The Subscriber
                    shall independently verify all reports, payment instructions
                    and outputs generated through the Platform before acting
                    upon them.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 11 :&nbsp;
                  <span className="text-pending">SERVICE AVAILABILITY</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    11.1 The Company shall use commercially reasonable efforts
                    to maintain availability of the Platform. However, the
                    Subscriber acknowledges that continuous, uninterrupted or
                    error-free operation cannot be guaranteed. The Platform may
                    become temporarily unavailable due to scheduled maintenance
                    and/or emergency maintenance and/or software upgrades and/or
                    internet failures and/or cloud infrastructure failures
                    and/or cyber-attacks and/or force majeure events and/or
                    failures of third-party providers and/or telecommunications
                    failures. It is clarified that such temporary interruptions
                    shall not constitute a breach of these Terms.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 12 :&nbsp;
                  <span className="text-pending">LIMITATION OF LIABILITY</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    12.1 To the maximum extent permitted by Applicable Law,
                    neither Party shall be liable to the other for any indirect,
                    incidental, consequential, special or punitive damages,
                    including loss of profits, business opportunities, goodwill
                    or anticipated savings. Subject to Applicable Law, the
                    aggregate liability of the Company arising out of or in
                    connection with these Terms shall not exceed the
                    Subscription fees actually paid by the Subscriber to the
                    Company during the six (6) months immediately preceding the
                    event giving rise to the claim.
                  </p>
                  <p className="text-justify">
                    12.2 The foregoing limitation shall not apply to liability
                    arising from fraud or fraudulent misrepresentation and/or
                    wilful misconduct and/or breach of confidentiality and/or
                    infringement of the Company’s Intellectual Property by the
                    Subscriber and/or liabilities that cannot lawfully be
                    excluded or limited.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 13 :&nbsp;
                  <span className="text-pending">INDEMNITY</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    13.1 The Subscriber shall indemnify, defend and hold
                    harmless the Company, its Affiliates, directors, officers,
                    employees and representatives from and against all claims,
                    losses, liabilities, damages, penalties, costs and expenses
                    (including reasonable legal fees) arising from the
                    Subscriber’s breach of these Terms and/or Subscriber’s
                    misuse of the Platform and/or the Subscriber’s violation of
                    the Applicable Law and/or infringement of any third-party
                    rights through the Subscriber Data and/or any negligent,
                    fraudulent or unlawful act or omission of the Subscriber or
                    persons authorized by it to use the Platform.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 14 :&nbsp;
                  <span className="text-pending">SUSPENSION</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    14.1 The Company may upon reasonable notice where
                    practicable, suspend or restrict the Subscriber’s access to
                    the Platform if the Subscriber commits a material breach of
                    these Terms and/or the continued access may compromise the
                    security, integrity or availability of the Platform and/or
                    the Company is required to do so by Applicable Law or a
                    governmental authority and/or the Subscriber fails to pay
                    fees/undisputed amounts due within the prescribed time
                    and/or the Company reasonably believes that the Platform is
                    being used for unlawful, fraudulent or unauthorized purposes
                    by the Subscriber.
                  </p>
                  <p className="text-justify">
                    14.2 Where reasonably possible, the Company shall provide
                    the Subscriber with an opportunity to remedy the breach
                    before suspension.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 15 :&nbsp;
                  <span className="text-pending">TERMINATION</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <p className="text-justify">
                    15.1 The Company may terminate the Subscriber’s access to
                    the Platform by written notice if the Subscriber commits a
                    material breach of these Terms and fails to remedy such
                    breach within thirty (30) days of receiving notice and/or
                    the Subscriber becomes insolvent, enters liquidation or
                    ceases to carry on business and/or continued provision of
                    the Services becomes unlawful and/or the Subscription
                    expires and is not renewed.
                  </p>
                  <p className="text-justify">
                    15.2 The Subscriber may discontinue use of the Platform upon
                    expiry or termination of its Subscription, subject to the
                    applicable commercial arrangements. Unless expressly agreed
                    otherwise, termination shall not entitle the Subscriber to
                    any refund of fees already paid.
                  </p>
                  <p className="text-justify">
                    15.3 Upon termination or expiry the Subscriber’s right to
                    access and use the Platform shall immediately cease and the
                    Subscriber shall cease using all software, documentation and
                    Company materials. Each Party shall return or securely
                    destroy the other Party’s Confidential Information, subject
                    to Applicable Law and legitimate backup retention policies.
                  </p>
                  <p className="text-justify">
                    15.4 Termination shall not affect any accrued rights,
                    obligations or liabilities of either Party. The provisions
                    relating to confidentiality, intellectual property,
                    indemnity, limitation of liability, dispute resolution and
                    all provisions which by their nature are intended to survive
                    shall continue in full force and effect.
                  </p>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="font-semibold text-font-md">
                  ARTICLE 16 :&nbsp;
                  <span className="text-pending">MISCELLANEOUS</span>
                </h2>
                <div className="gap-2.5 flex flex-col">
                  <div>
                    <p>
                      16.1&nbsp;
                      <span className="font-semibold">
                        Entire Understanding
                      </span>
                    </p>
                    <p className="text-justify">
                      These Terms constitute the entire understanding governing
                      the Subscriber’s access to and use of the Platform and
                      supersede all prior discussions, understandings and
                      communications relating to the subject matter hereof,
                      except for any applicable quotation, invoice terms or
                      other commercial document executed between the Parties.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.2&nbsp;
                      <span className="font-semibold">
                        Amendments to these Terms
                      </span>
                    </p>
                    <p className="text-justify">
                      The Company may amend these Terms from time to time to
                      reflect changes in the Applicable Law and/or regulatory
                      requirements and/or technology and/or security standards
                      and/or business practices and/or the Services. Material
                      changes shall become effective upon publication on the
                      website or such later date as specified/ communicated by
                      the Company. Continued use of the Platform after the
                      effective date of the revised Terms shall constitute
                      acceptance of the revised Terms. Where Applicable Law
                      requires express consent for a particular amendment, the
                      Company shall obtain such consent through an appropriate
                      acceptance mechanism.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.3&nbsp;
                      <span className="font-semibold">
                        Assignment and Severability
                      </span>
                    </p>
                    <p className="text-justify">
                      (a) The Subscriber shall not assign, transfer or otherwise
                      deal with its rights or obligations under these Terms
                      without the Company’s prior written consent. The Company
                      may assign or transfer its rights and obligations to any
                      Affiliate or successor in connection with a merger,
                      acquisition, business transfer or corporate restructuring.
                    </p>
                    <p className="text-justify">
                      (b) If any term, provision or part of these Terms is to
                      any extent held invalid, void or unenforceable by a court
                      of competent jurisdiction, the remainder of these Terms,
                      as applicable, will not be affected thereby, and each
                      term, provision and part will continue in full force and
                      effect, and will be valid and enforceable to the fullest
                      extent permitted by law.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.4&nbsp;
                      <span className="font-semibold">
                        Independent Relationship
                      </span>
                    </p>
                    <p className="text-justify">
                      Nothing contained in these Terms shall be construed as
                      creating any partnership, joint venture, agency, fiduciary
                      or employment relationship between the Parties.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.5 &nbsp;
                      <span className="font-semibold">Force Majeure</span>
                    </p>
                    <p className="text-justify">
                      Neither Party shall be liable for any delay or failure in
                      performing its obligations to the extent caused by events
                      beyond its reasonable control, including acts of God,
                      natural disasters, war, terrorism, civil unrest, strikes,
                      epidemics, governmental actions, interruption of
                      telecommunications, internet failures or widespread cyber
                      incidents. The affected Party shall promptly notify the
                      other Party and use reasonable efforts to mitigate the
                      effects of the Force Majeure event.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.6 &nbsp;
                      <span className="font-semibold">
                        Audit and Compliance
                      </span>
                    </p>
                    <p className="text-justify">
                      Where reasonably required for security, regulatory or
                      contractual compliance purposes, the Company may verify
                      the Subscriber’s compliance with these Terms, provided
                      that such verification shall be conducted during normal
                      business hours and in a manner that does not unreasonably
                      interfere with the Subscriber’s business operations.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.7 &nbsp;
                      <span className="font-semibold">
                        Governing Law and Jurisdiction
                      </span>
                    </p>
                    <p className="text-justify">
                      These Terms shall be governed by, interpreted and
                      construed in accordance with the laws of India without
                      regard to its conflict of law principles.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.8 &nbsp;
                      <span className="font-semibold">Courts</span>
                    </p>
                    <p className="text-justify">
                      The Parties agree that the Courts in Mumbai, Maharashtra
                      alone shall have the exclusive jurisdiction to entertain
                      any proceedings for any relief related to these Terms.
                      Each of the Parties shall bear its own costs and expenses.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.9 &nbsp;
                      <span className="font-semibold">Notice</span>
                    </p>
                    <p className="text-justify">
                      Any Notice(s) required or provided under these Terms shall
                      be given in writing either by personal delivery, e-mail,
                      or speed/ registered post, addressed to the address
                      mentioned in these Terms. All notices shall be deemed to
                      be effective on the date of receipt.
                    </p>
                  </div>
                  <div>
                    <p>
                      16.10 &nbsp;
                      <span className="font-semibold">Waiver</span>
                    </p>
                    <p className="text-justify">
                      No failure or delay by either Party in exercising any
                      right under these Terms shall operate as a waiver of that
                      right.
                    </p>
                  </div>
                </div>
              </div>
              <div className="gap-5 flex flex-col">
                <h2 className="text-pending font-semibold text-font-md">
                  ACKNOWLEDGEMENT OF TERMS OF USE
                </h2>
                <div className="gap-1 flex flex-col">
                  <p className="text-justify">
                    The undersigned, being duly authorized to act on behalf of
                    the Subscriber, hereby acknowledges and confirms that the
                    Subscriber:
                  </p>
                  <p className="text-justify">
                    (a) has received, carefully reviewed and understood these
                    Terms of Use;
                  </p>
                  <p className="text-justify">
                    (b) voluntarily accepts and agrees to be legally bound by
                    these Terms;
                  </p>
                  <p className="text-justify">
                    (c) shall ensure that every individual authorised by it to
                    access or use the Platform complies with these Terms, and
                    acknowledges that the acts and omissions of such persons
                    shall be deemed to be those of the Subscriber;
                  </p>
                  <p className="text-justify">
                    (d) acknowledges that these Terms govern all present and
                    future access to and use of the Platform unless replaced or
                    amended in accordance with these Terms.
                  </p>
                </div>
              </div>
              <p className="text-justify">Last updated on : January 1, 2026</p>
            </div>
            {/* <div className="flex flex-1 bg-[#1d3a6d]"></div> */}
            <Footer />
          </div>
        </>
      </div>
    </div>
  );
};

export default TermsConditions;
